import { Link, NavLink } from "react-router-dom";
import { BnkleLogoFull } from "assets/svg";
import { footerSections } from "./constants";
import { FC } from "react";

const FooterSection: FC = () => {
  return (
    <footer className="bg-blueShades-6">
      <div className="py-16 px-4 md:px-16">
        <div className="flex flex-col gap-10 referral-container">
          <div className="flex flex-col md:flex-row md:justify-between gap-12">
            <p className="text-base md:text-xs lg:text-base text-blueShades-7 font-SatoshiMedium md:w-[250px] lg:w-[450px]">
              Our Mission at Bankolé is to connect smart tools and affordable
              capital to build out Africa’s housing and infrastructure deficit.
            </p>
            <div className="flex flex-col sm:flex-row gap-10 text-blueShades-7 text-sm font-SatoshiMedium">
              {footerSections.map((section) => (
                <div key={section.title} className="flex flex-col gap-3">
                  <p className="font-SatoshiBold text-sm md:text-xs lg:text-sm whitespace-nowrap">
                    {section.title}
                  </p>
                  {section.links.map((link) =>
                    link.type === "internal" ? (
                      <Link
                        key={link.label}
                        to={link.to!}
                        className="hover:underline font-SatoshiMedium text-sm md:text-xs lg:text-sm whitespace-nowrap flex items-center gap-2"
                      >
                        {link.label}
                      </Link>
                    ) : (
                      <a
                        key={link.label}
                        href={link.href}
                        target="_blank"
                        rel="noreferrer"
                        className="hover:underline font-SatoshiMedium text-sm md:text-xs lg:text-sm whitespace-nowrap flex items-center gap-2"
                      >
                        {link.label}
                      </a>
                    )
                  )}
                </div>
              ))}
            </div>
          </div>

          <NavLink
            to="/"
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          >
            <img
              src={BnkleLogoFull}
              alt="bnkle"
              className="h-[63px] md:h-[140px] w-[220px] md:w-[400px] lg:w-[600px]"
            />
          </NavLink>
        </div>
      </div>
    </footer>
  );
};

export default FooterSection;
